"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChatMessageDefinition {
}
ChatMessageDefinition.CONTENT_TYPE_TEXT_PLAIN = "text/plain";
ChatMessageDefinition.CONTENT_TYPE_IMG_JPEG = "image/jpeg";
ChatMessageDefinition.CONTENT_TYPE_IMG_PNG = "image/png";
ChatMessageDefinition.CONTENT_TYPE_AUDIO_AAC = "audio/aac";
ChatMessageDefinition.CONTENT_TYPE_AUDIO_WAV = "audio/wav";
ChatMessageDefinition.CONTENT_TYPE_AUDIO_WEBM = "audio/webm";
exports.ChatMessageDefinition = ChatMessageDefinition;
//# sourceMappingURL=ChatMessageDefinition.js.map